module.exports = __webpack_public_path__ + "img/fn-bottom-txt.42ec44ac.jpg";